import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0px',
    padding: '15px',
    borderBottom: '1px solid rgba(149, 149, 149, 0.4)',
  },
  title: {
    paddingBottom: '15px',
    marginBottom: '15px',
    borderBottom: '1px solid rgba(149, 149, 149, 0.4)',
  },
  input: {
    width: '100%',
    margin: '0px',
    padding: '15px',
    border: '2px solid #F97F11',
    borderRadius: '4px',
    fontWeight: '700',
  },
}));

export default useStyles;
